import React, { use, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  Pagination,
} from "@mui/material";
import { format } from "date-fns";
import theme from "../theme/theme";
import { getProjectTaskList } from "../apis/apiList/projectApi";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { getEditorList } from "../apis/apiList/userApi";

const mockProjects = [
  {
    id: 1,
    title: "Website Redesign",
    organization: "Acme Corp",
    dueDate: "2025-06-18",
    status: "Active",
    tasks: 10,
    overdueTasks: 2,
    owner: "Jane Doe",
  },
  {
    id: 2,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 3,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 4,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 5,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 6,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 7,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  {
    id: 8,
    title: "Marketing Campaign",
    organization: "Beta Ltd",
    dueDate: "2025-06-20",
    status: "Active",
    tasks: 5,
    overdueTasks: 0,
    owner: "Mike Ross",
  },
  // Add more mock projects as needed
];

const ITEMS_PER_PAGE = 10;

const taskTableHeader = {
  color: "#fff",
};

export default function TaskReport() {
  const [search, setSearch] = useState("");
  const [orgFilter, setOrgFilter] = useState("All");
  const [sortAsc, setSortAsc] = useState(true);
  const [page, setPage] = useState(1);
  const [taskList, setTaskList] = useState([]);
  const navigate = useNavigate();
  const [editorFilter, setEditorFilter] = useState("All");
  const [editorOptions, setEditorOptions] = useState([]);

  const { userDetails } = useApp();

  useEffect(() => {
    async function getTaskList() {
      try {
        const res = await getProjectTaskList({
            headers: {
              "x-access-token": userDetails.jwtToken,
            }
        });
        console.log("res task list", res);
        setTaskList(res?.data || []);
      } catch (err) {
        console.error("Failed to fetch task list:", err);
      }
    }

    getTaskList();

    async function getEditors() {
      try {
        const editorsList = await getEditorList();
        console.log("editors list", editorsList.data);
        const editorOptionsList = [
          "All",
          ...new Set(
            editorsList.data
              .map((u) => `${u.firstName} ${u.lastName}`)
          ),
        ];
        setEditorOptions(editorOptionsList);
      } catch (error) {
        console.log('error', error) 
      }
    }
    getEditors();
  }, []);

  const orgOptions = [
    "All",
    ...new Set(
      taskList.map((p) => {
        // console.log('org name', p.orgId.organizationName)
        // if(p.orgId.organizationName){
        // }
        return p.orgId.organizationName;
      })
    ),
  ];

  // const editorOptions = [
  //   "All",
  //   ...new Set(
  //     taskList
  //       .flatMap((p) => p.associatedUsers || [])
  //       .map((u) => `${u.firstName} ${u.lastName}`)
  //   ),
  // ];

  // const filteredProjects = taskList
  //   .filter((p) =>
  //     orgFilter === "All" ? true : p.orgId.organizationName === orgFilter
  //   )
  //   .filter(
  //     (p) =>
  //       p.projectName.toLowerCase().includes(search.toLowerCase()) ||
  //       p.orgId.organizationName.toLowerCase().includes(search.toLowerCase())
  //   )
  //   .sort((a, b) =>
  //     sortAsc
  //       ? new Date(a.dueDate) - new Date(b.dueDate)
  //       : new Date(b.dueDate) - new Date(a.dueDate)
  //   );

  // const paginatedProjects = filteredProjects.slice(
  //   (page - 1) * ITEMS_PER_PAGE,
  //   page * ITEMS_PER_PAGE
  // );

  // const paginatedProjects = taskList
  // .filter((p) => orgFilter === "All" || p.orgId.organizationName === orgFilter)
  // .filter((p) =>
  //   p.projectName.toLowerCase().includes(search.toLowerCase()) ||
  //   p.orgId.organizationName.toLowerCase().includes(search.toLowerCase())
  // )
  // .filter((p) =>
  //   editorFilter === "All"
  //     ? true
  //     : (p.associatedUsers || []).some(
  //         (u) => `${u.firstName} ${u.lastName}` === editorFilter
  //       )
  // )
  // .sort((a, b) =>
  //   sortAsc
  //     ? new Date(a.dueDate) - new Date(b.dueDate)
  //     : new Date(b.dueDate) - new Date(a.dueDate)
  // );

  const getAssignedToUser = (user) => {
    if (!user || !user.firstName) return "Not Assigned";
    return `${user.firstName} ${user.lastName}`;
  };


  const filteredProjects = taskList
  .filter((p) => orgFilter === "All" || p.orgId.organizationName === orgFilter)
  .filter((p) =>
    p.projectName.toLowerCase().includes(search.toLowerCase()) ||
    p.orgId.organizationName.toLowerCase().includes(search.toLowerCase())
  )
  .filter((p) =>
    editorFilter === "All"
      ? true
      : getAssignedToUser(p.associatedUsers) === editorFilter
  )
  .sort((a, b) =>
    sortAsc
      ? new Date(a.dueDate) - new Date(b.dueDate)
      : new Date(b.dueDate) - new Date(a.dueDate)
  );

const paginatedProjects = filteredProjects.slice(
  (page - 1) * ITEMS_PER_PAGE,
  page * ITEMS_PER_PAGE
);
  

  const getTask = (approvals) => {

    if (!approvals) return "Script and Visuals";
    
    const pendingStages = Object.keys(approvals)
      .map((stage) => {
        if (!approvals[stage]) {
          switch (stage) {
            case "scriptsAndVisuals":
              return "Script and Visuals";
            case "voiceOver":
              return "Voice Over";
            case "video":
              return "Video";
            default:
              return null;
          }
        }
        return null;
      })
      .filter((stage) => stage !== null);

    // console.log("pendingStages", pendingStages);
    return pendingStages.join(", ");
  };

  
  // const getAssignedToUser = (users) => {
  //   console.log("users", users);
  //   if (!users || !users.length) return "Not Assigned";
  //   return `${users[0].firstName}  ${users[0].lastName}`;
  // };


  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const handleViewProject = (project) => {
    // navigate(`/org/${project.orgId._id}/project/view/${project._id}`);
    openInNewTab(`/org/${project.orgId._id}/project/view/${project._id}`);
  };

  return (
    <Box>
      <Box
        sx={{
          //   backgroundColor: "#f5f5f5",
          borderRadius: 2,
          px: 3,
          py: 2,
          mb: 1,
          //   boxShadow: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          variant="h3"
          sx={{ fontWeight: "bold", color: "#222", mb: 2.5 }}
        >
          {/* 📋 Task Report */}
          Task Report
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "center",
            mb: 3,
          }}
        >
          <Autocomplete
            className="org-autocomplete"
            size="small"
            options={orgOptions}
            value={orgFilter}
            onChange={(e, newValue) => setOrgFilter(newValue || "All")}
            renderInput={(params) => (
              <TextField
                className="org-search-input"
                {...params}
                label="Filter by Organization"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingTop: "0px !important",
                    paddingBottom: "0px !important",
                  },
                  "& .MuiInputBase-input": {
                    paddingTop: "0px !important",
                    paddingBottom: "0px !important",
                  },
                }}
              />
            )}
            sx={{ minWidth: 220, width: "500px" }}
          />

          <TextField
            size="small"
            label="Search Projects"
            value={search}
            sx={{ minWidth: 220, width: {xs: "100%", md: "400px"} }}
            onChange={(e) => setSearch(e.target.value)}
          />

          {userDetails?.role === "admin" && ( userDetails.jobTitle == 'admin' || userDetails.jobTitle == 'Actor' || userDetails.jobTitle == 'Production Manager' ) && (  
            <Autocomplete
              size="small"
              options={editorOptions}
              value={editorFilter}
              onChange={(e, newValue) => setEditorFilter(newValue || "All")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Filter by Editor"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingTop: "0px !important",
                      paddingBottom: "0px !important",
                    },
                    "& .MuiInputBase-input": {
                      paddingTop: "0px !important",
                      paddingBottom: "0px !important",
                    },
                  }}
                />
              )}
              sx={{ minWidth: 220, width: { xs: "100%", md: "300px" } }}
            />
          )}

          {/* <Button
                variant="outlined"
                onClick={() => setSortAsc((prev) => !prev)}
            >
                Sort by Due Date {sortAsc ? "↑" : "↓"}
            </Button> */}
        </Box>
        {paginatedProjects.length > 0 ? (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#495967" }}>
                    <TableCell sx={taskTableHeader}>Project Title</TableCell>
                    <TableCell sx={taskTableHeader}>Organization</TableCell>
                    <TableCell sx={taskTableHeader}>Due Date</TableCell>
                    <TableCell sx={taskTableHeader}>Status</TableCell>
                    <TableCell sx={taskTableHeader}>Tasks</TableCell>
                    <TableCell sx={taskTableHeader}>Assigned To</TableCell>
                    <TableCell sx={taskTableHeader}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedProjects.length > 0 && paginatedProjects.map((project) => (
                    <TableRow key={project.id}>
                      <TableCell>{project.projectName}</TableCell>
                      <TableCell>{project.orgId.organizationName}</TableCell>
                      <TableCell>
                        {project.dueDate != null ? format(new Date(project.dueDate), "PPP"): "TBD"}
                      </TableCell>
                      <TableCell>{project.status}</TableCell>
                      <TableCell>{getTask(project.approvals)}</TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>{getAssignedToUser(project.associatedUsers)}</TableCell>
                      {/* <TableCell sx={{ textTransform: "capitalize" }}>
                        {getAssignedToUser(project.associatedUsers)}
                      </TableCell> */}
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleViewProject(project)}
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box display="flex" justifyContent="center" mt={2}>
              {/* <Pagination
                count={Math.ceil(paginatedProjects.length / ITEMS_PER_PAGE)}
                page={page}
                onChange={(e, value) => setPage(value)}
                color="primary"
              /> */}
              <Pagination
                count={Math.ceil(filteredProjects.length / ITEMS_PER_PAGE)}
                page={page}
                onChange={(e, value) => setPage(value)}
                color="primary"
              />
            </Box> 
          </>
        ) : (
            <Box
                mt={6}
                textAlign="center"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="40vh"
                color="text.secondary"
            >
                <img
                    src="/images/no-task-vector.jpg"
                    alt="No Tasks Found"
                    style={{ width: 400, height: "auto", marginBottom: 16, opacity: 0.6 }}
                />
                {/* <Typography variant="h6" gutterBottom>
                    No active projects found
                </Typography> */}
            </Box>
        )}
      </Box>
    </Box>
  );
}
